export default __webpack_public_path__ + "static/media/formImageTwo.e79e16cf.jpg";